import { render } from "./Accounting.vue?vue&type=template&id=24013246"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__